export function renderDbBarrelContentTemplate({
  exportLinesContent
}: {
  exportLinesContent: string
}): string {
  return `export * from './core/schema'
${exportLinesContent}`
}
